<template>
	<div class="top">
		<div class="top_con w-1440 d-flex a-center j-sb">
			<div class="fl">{{huanyingyu}}</div>
			<div class="fr">
				<div class="t">今天是：{{times}}</div>
				<div class="dl d-flex a-center j-end">
					<template v-if="userInfo">
						<div class="xx">
							您好，{{userInfo.nickname?userInfo.nickname:userInfo.phone}} |
						</div>
						<div class="tc cursor" @click="btnClick('out')">
							退出
						</div>
						<div class="nr d-flex a-center j-center">
							<router-link to="/member/index" class="a">会员中心</router-link>
						</div>
					</template>
					<template v-else>
						<div class="nr d-flex a-center j-center">
							<router-link to="/login/login">登录</router-link>/<router-link
								to="/login/reg">注册</router-link>
						</div>
						<div class="nr2 ml-20 ">
							<router-link to="/login/reg" class="a d-flex a-center j-center">个人中心<img
									src="@/assets/images/head_mem.jpg" class="ml-10" /></router-link>
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "nodata",
		data() {
			return {
				times: '',
				huanyingyu: '',
				userInfo: ''
			}
		},
		mounted() {
			this.times = this.$common.getDateTime(1)
			this.getBaseInfo()

			var token = window.localStorage.getItem('GAOYANGNONGYE_PC_ACCESS_TOKEN')
			if (token) {
				var token_time = window.localStorage.getItem('GAOYANGNONGYE_PC_ACCESS_TOKEN_TIME')
				if (token_time) {
					var date1 = new Date(token_time);
					var date2 = new Date();
					if (date1 > date2) {
						var userInfo = window.localStorage.getItem('GAOYANGNONGYE_PC_USERINFO')
						this.userInfo = userInfo ? JSON.parse(userInfo) : ''
					}
				}
			}
		},
		methods: {
			btnClick(e) {
				const that = this
				if (e == 'out') {
					window.localStorage.removeItem('GAOYANGNONGYE_PC_USERINFO')
					window.localStorage.removeItem('GAOYANGNONGYE_PC_USERID')
					window.localStorage.removeItem('GAOYANGNONGYE_PC_ACCESS_TOKEN')

					window.location.href = "/"
				}

			},
			getBaseInfo() {
				var that = this;

				var baseInfo = window.localStorage.getItem('GAOYANGNONGYE_PC_baseInfo')
				if (baseInfo) {
					baseInfo = JSON.parse(baseInfo)
					var cha = new Date().getTime() - new Date(baseInfo.time).getTime()
					if (cha < 14400000) {
						that.huanyingyu = baseInfo.data.huanyingyu
					} else {
						that.$axios.post(that.$baseUrl.baseInfo, {})
							.then(res => {
								if (res.code == 200) {
									that.huanyingyu = res.data.huanyingyu
									var data = {
										time: new Date(),
										data: res.data
									}
									window.localStorage.setItem('GAOYANGNONGYE_PC_baseInfo', JSON.stringify(data))
								} else {
									that.$toast(res.msg);
								}
							})
							.catch(error => {
								console.error(error)
							})
					}
				} else {
					that.$axios.post(that.$baseUrl.baseInfo, {})
						.then(res => {
							if (res.code == 200) {
								that.huanyingyu = res.data.huanyingyu

								var data = {
									time: new Date(),
									data: res.data
								}

								window.localStorage.setItem('GAOYANGNONGYE_PC_baseInfo', JSON.stringify(data))
							} else {
								that.$toast(res.msg);
							}
						})
						.catch(error => {
							console.error(error)
						})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.top {
		background-color: #eaefe8;

		.top_con {
			height: 45px;

			.fl {
				font-size: 18px;
				color: #b1b1b1;
				line-height: 45px;
			}

			.fr {
				font-size: 16px;
				color: #8f8f8f;
				display: flex;
				align-items: center;

				.t {
					float: left;
					width: 250px;
					line-height: 24px;
				}

				.dl {
					float: left;

					.a {
						color: #2a9514;
					}

					.xx {
						color: #2a9514;
						margin-right: 8px;

					}

					.mr-3 {
						margin-right: 30px;
					}

					.tc {
						width: 40px;
						background: #e2f9e8;
						border: 1px solid #7db572;
						border-radius: 4px;
						color: #389423;
						margin-right: 8px;
						text-align: center;
					}

					.nr {
						padding: 0 10px;
						height: 32px;
						background: #389423;
						border-radius: 6px;
						line-height: 32px;
						color: #e2ece9;
						font-size: 16px;

						a {
							color: #e2ece9;
						}
					}
				}
			}
		}
	}
</style>